import TRANSLATION_CLIENT_EN from '../locales/clientLabels/en.json';
import TRANSLATION_CLIENT_IT from '../locales/clientLabels/it.json';
import TRANSLATION_CLIENT_ES from '../locales/clientLabels/es.json';
import TRANSLATION_CLIENT_DE from '../locales/clientLabels/de.json';
import TRANSLATION_DB_EN from '../locales/dbLabels/en.json';
import TRANSLATION_DB_IT from '../locales/dbLabels/it.json';
import TRANSLATION_DB_ES from '../locales/dbLabels/es.json';
import TRANSLATION_DB_DE from '../locales/dbLabels/de.json';
import TRANSLATION_ERRORS_EN from '../locales/errors/en.json';
import TRANSLATION_ERRORS_IT from '../locales/errors/it.json';
import TRANSLATION_ERRORS_ES from '../locales/errors/es.json';
import TRANSLATION_ERRORS_DE from '../locales/errors/de.json';

export enum LANGUAGE_CODES {
	EN_GB = 'en-gb', //this is an exception for dayjs
	EN = 'en',
	IT = 'it',
	ES = 'es',
	DE = 'de',
}

export const LANGUAGES = [
	{ id: 'en-gb', label: 'English (UK)', localeDayjs: LANGUAGE_CODES.EN_GB },
	{ id: 'en-us', label: 'English (US)', localeDayjs: LANGUAGE_CODES.EN },
	{ id: 'it-it', label: 'Italiano', localeDayjs: LANGUAGE_CODES.IT },
	{ id: 'es-es', label: `Espa\u00f1ol`, localeDayjs: LANGUAGE_CODES.ES },
	{ id: 'de-de', label: 'Deutsch', localeDayjs: LANGUAGE_CODES.DE },
];

export const DEFAULT_LANGUAGE = {
	[LANGUAGE_CODES.EN]: {
		translation: {
			clientLabels: TRANSLATION_CLIENT_EN,
			dbLabels: TRANSLATION_DB_EN,
			errors: TRANSLATION_ERRORS_EN,
		},
	},
	[LANGUAGE_CODES.IT]: {
		translation: {
			clientLabels: TRANSLATION_CLIENT_IT,
			dbLabels: TRANSLATION_DB_IT,
			errors: TRANSLATION_ERRORS_IT,
		},
	},
	[LANGUAGE_CODES.ES]: {
		translation: {
			clientLabels: TRANSLATION_CLIENT_ES,
			dbLabels: TRANSLATION_DB_ES,
			errors: TRANSLATION_ERRORS_ES,
		},
	},
	[LANGUAGE_CODES.DE]: {
		translation: {
			clientLabels: TRANSLATION_CLIENT_DE,
			dbLabels: TRANSLATION_DB_DE,
			errors: TRANSLATION_ERRORS_DE,
		},
	},
};
